import { dedupeTranscript } from "./parseEnquiryTranscript";

/** Normalize whitespace for speech segment comparison. */
function normalizeSegment(text) {
  return String(text || "").replace(/\s+/g, " ").trim();
}

/**
 * Merge speech segments when the browser returns cumulative/overlapping chunks
 * (common on Chrome and Android WebView).
 */
export function mergeSpeechSegments(parts) {
  let combined = "";

  for (const raw of parts) {
    const part = normalizeSegment(raw);
    if (!part) continue;

    if (!combined) {
      combined = part;
      continue;
    }

    const prev = combined.toLowerCase();
    const next = part.toLowerCase();

    if (next.startsWith(prev)) {
      combined = part;
      continue;
    }

    if (prev.startsWith(next)) {
      continue;
    }

    const maxOverlap = Math.min(combined.length, part.length);
    let overlap = 0;
    for (let len = maxOverlap; len > 0; len -= 1) {
      if (prev.slice(-len) === next.slice(0, len)) {
        overlap = len;
        break;
      }
    }

    combined = overlap > 0 ? combined + part.slice(overlap) : `${combined} ${part}`;
  }

  return normalizeSegment(combined);
}

/** Combine finalized text with the latest interim hypothesis without repeating words. */
export function combineFinalAndInterim(finalText, interimText) {
  const finalPart = normalizeSegment(finalText);
  const interimPart = normalizeSegment(interimText);

  if (!interimPart) return finalPart;
  if (!finalPart) return interimPart;

  const finalLower = finalPart.toLowerCase();
  const interimLower = interimPart.toLowerCase();

  if (interimLower.startsWith(finalLower)) {
    return normalizeSegment(interimPart);
  }

  return mergeSpeechSegments([finalPart, interimPart]);
}

/** Build a clean live transcript from finalized + interim speech results. */
export function buildLiveTranscript(finalText, interimText) {
  return dedupeTranscript(combineFinalAndInterim(finalText, interimText));
}
